
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Vue from 'vue'
import { VBtn, VIcon } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcBtn',
  components: {
    VBtn,
    VIcon,
  },
  props: {
    color: { type: String, default: '' },
    secondary: { type: Boolean, default: false },
    tertiary: { type: Boolean, default: false },
    // TODO: Remove expansion type. Pulled settings into expansion and table.
    type: {
      type: String,
      default: 'button',
      validator: (prop: string) =>
        ['button', 'reset', 'submit', 'expansion', 'close'].includes(prop),
    },
    loading: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    iconRight: { type: Boolean, default: false },
    align: { type: String, default: 'left' },
    small: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
    target: { type: String, default: undefined },
    ariaLabel: { type: String, default: undefined },
    href: { type: String, default: undefined },
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
  },
  computed: {
    tertiaryCalc(): boolean {
      if (this.tertiary) return true
      else if (this.type === 'reset') return true
      return false
    },
    // Icon Only/Location
    // Set icon by button type
    iconCalc() {
      if (this.loading) return 'mdi-loading mdi-spin'
      else if (this.type === 'reset') return '$reset'
      else if (this.type === 'submit') return '$send'
      else if (this.type === 'expansion') return '$expand'
      else if (this.type === 'close') return '$cancel'
      return this.icon
    },
    // Icon only when slot is empty
    iconOnlyCalc() {
      if (this.iconOnly) return true
      else if (this.type === 'close') return true
      else if (this.$slots.default) return false
      return true
    },
    // Show/hide icons based on icon settings
    iconOnlyLocation() {
      if (this.iconOnlyCalc) return 'null'
      else if (
        (this.iconRight && this.iconCalc != '') ||
        this.type === 'submit' ||
        this.type === 'expansion'
      )
        return 'right'
      else if (this.iconCalc != '') return 'left'
      return 'null'
    },
    smallCalc() {
      if (this.small) return true
      if (this.type === 'close') return true
      return false
    },

    // CLASSES

    // Adjust spacing based on alignment
    alignClass() {
      if (this.align === 'left') return 'mr-1'
      else if (this.align === 'right') return 'ml-1'
      else if (this.align === 'no-gutter') return 'ma-0'
      return 'mx-h'
    },
    // Adjust text color based on background color
    textColorClass() {
      if (
        !this.iconOnlyCalc &&
        (this.color === 'warning' || this.color === 'info')
      )
        if (this.secondary || this.tertiary)
          return `${this.color}--text text--darken-2`
        else return `${this.color}--text text--darken-3`
      else if (this.active) return `${this.color}--text text--darken-1`
      return ''
    },
    // Combine classes
    btnClass(): string {
      const lighten = this.active ? 'v-btn--active lighten-5' : ''
      return `${this.alignClass} ${
        this.type === 'close' ? '' : this.textColorClass
      } ${this.type} ${lighten}`
    },
    // Type
    typeCalc() {
      if (this.type === 'reset' || this.type === 'submit') return this.type
      return undefined
    },
  },
  render() {
    // The container node is expected to provide a single root,
    // so it's okay to return `VNode[]` as any.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    return this.$scopedSlots.default!({}) as any
  },
})
